module.exports = __webpack_public_path__ + "static/media/thumbnail.a59ba41a.webp";